import React from 'react';
import {Card, Col, Row, Spin, Typography} from 'antd';
import EngageCurrency from '../billings/EngageCurrency';
import {SharesOwnedProps} from '../../types/purchaseTypes';

const {Text} = Typography;

const SharesOwned = ({loading, numberOfShares, totalValue, shareOwner}: SharesOwnedProps) => {
    return (
        <Col xs={24} sm={16} md={16} lg={12} xl={8}>
            <Card title="Shares Owned" className="details-card">
                {loading ? (
                    <Spin spinning={loading}/>
                ) : (
                    <>
                        <Row>
                            <Col xs={24} md={12}>
                                <Text strong>Number of shares:</Text>
                            </Col>
                            <Col xs={24} md={10}>
                                {numberOfShares}
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={12}>
                                <Text strong>Total share value:</Text>
                            </Col>
                            <Col xs={24} md={10}>
                                <EngageCurrency amount={totalValue}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={12}>
                                <Text strong>Owned by:</Text>
                            </Col>
                            <Col xs={24} md={10}>
                                {shareOwner}
                            </Col>
                        </Row>
                    </>
                )}
            </Card>
        </Col>
    );
};

export default SharesOwned;
